export default "__VITE_ASSET__ebb0d383__"